import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRedirectResult, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../lib/firebase';
import { Loading } from '@/components/ui/loading';

/**
 * This component handles the authentication redirect from Firebase
 * It's specifically designed to catch the /__/auth/handler route
 */
const AuthHandler: React.FC = () => {
  const navigate = useNavigate();
  const [processingAuth, setProcessingAuth] = useState(true);
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    
    
    

    // Set up auth state listener first to catch any auth state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      

      if (user) {
        // User is signed in, we can proceed with redirect
        const redirectUrl = localStorage.getItem('authRedirectUrl');
        if (redirectUrl) {
          
          localStorage.removeItem('authRedirectUrl');
          window.location.href = redirectUrl;
        } else {
          
          navigate('/');
        }
        setProcessingAuth(false);
      }
    });

    // Then check for redirect result
    const handleRedirect = async () => {
      try {
        
        const result = await getRedirectResult(auth);

        if (result) {
          
          // The auth state listener will handle the redirect
        } else {
          

          // Check if user is already signed in
          if (auth.currentUser) {
            
            const redirectUrl = localStorage.getItem('authRedirectUrl');
            if (redirectUrl) {
              
              localStorage.removeItem('authRedirectUrl');
              window.location.href = redirectUrl;
            } else {
              
              navigate('/');
            }
          } else {
            
            setAuthError('Authentication failed. Please try again.');
            setTimeout(() => navigate('/'), 2000);
          }
        }
      } catch (error: any) {
        
        setAuthError(`Authentication error: ${error.message}`);
        setTimeout(() => navigate('/'), 3000);
      } finally {
        setProcessingAuth(false);
      }
    };

    handleRedirect();

    // Clean up the auth state listener
    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {processingAuth ? (
        <>
          <div className="flex items-center mb-4">
            <Loading size={40} />
            <p className="ml-4 text-lg">Processing authentication...</p>
          </div>
          <p className="text-sm text-gray-500">This may take a few moments</p>
        </>
      ) : authError ? (
        <div className="text-center">
          <p className="text-red-500 mb-2">{authError}</p>
          <p className="text-sm">Redirecting to home page...</p>
        </div>
      ) : (
        <div className="text-center">
          <p className="text-green-500 mb-2">Authentication successful!</p>
          <p className="text-sm">Redirecting...</p>
        </div>
      )}
    </div>
  );
};

export default AuthHandler;

